import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.label = this.el.getAttribute('data-popup-label') || 'popup_winpharma';
        const duration = Number.parseInt(this.el.getAttribute('data-popup-duration'), 10);
        this.duration = Number.isNaN(duration) ? 365 : duration;

        this.events = {
            click: {
                close: 'close'
            }
        }

        if (this.duration === 0) {
            this.deleteCookie(this.label);
            this.open();
        } else if (!this.checkCookie(this.label)) {
            this.open();
            this.setCookie(this.label, "Ok", this.duration);
        }
    }

    open() {
        this.el.classList.add('-opened');
        setTimeout(() => {
            this.call('stop', 'Scroll');
        }, 200);
    }

    close() {
        this.el.classList.remove('-opened');
        this.call('start', 'Scroll');
    }
    
    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    deleteCookie(cname) {
        document.cookie = cname + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";
    }
    
    getCookie(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    checkCookie(cookieName) {
        let cookieValue = this.getCookie(cookieName);
        return (cookieValue == "Ok");
    }
}
